import type { ModelData } from '../../types'

export const dragonNarozneAku: { [key: string]: ModelData } = {
  'dragon-aku-2b': {
    id: 'dragon-aku-2b',
    name: 'DRAGON AKU 2B',
    power: '12 kW',
    type: 'powietrzny-aku',
    glassType: 'narozna',
    image: 'images/dragon-aku-2b.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 2B',
    description: 'Wkład powietrzny narożny akumulacyjny 12 kW',
    specialNote: 'Dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych.',
    basePrices: {
      standard: { 
        single: 9420,
        'single-connected': 10490,
        double: 11560,
        'double-connected': 12630
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 600,
          'flush-30': 690,
          'recessed-15': 790,
          'recessed-30': 900,
          'recessed-15-45': 990
        }
      },
      fusion: {
        none: 0,
        fusion: 500,
        'fusion-modules': 200
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      glassSize: '760 x 469 mm / 419 mm',
      height: '755 mm',
      width: '674 mm',
      depth: '450 mm',
      weight: '150 kg'
    },
    perkData: {
      variant: {
        standard: { icon: '??', value: 'Standard', color: '#4a9eff' }
      },
      glass: {
        single: { icon: '??', value: 'x1 (S2)', color: '#e6f3ff' },
        'single-connected': { icon: '??', value: 'x1 (S6)', color: '#e6f3ff' },
        double: { icon: '??', value: 'x2 (S3)', color: '#b3d9ff' },
        'double-connected': { icon: '??', value: 'x2 (S7)', color: '#b3d9ff' }
      },
      ceramic: {
        'refrabox-light': { icon: '??', value: 'Jasna', color: '#f5f1e8' },
        'cerabox-graphite': { icon: '??', value: 'Grafitowa', color: '#4a4a4a' }
      },
      handle: {
        'classic-black': { icon: '??', value: 'Classic', color: '#333' },
        'classic-silver': { icon: '??', value: 'Classic', color: '#c0c0c0' },
        'design-black': { icon: '??', value: 'Design', color: '#1a1a1a' },
        'design-black-silver': { icon: '??', value: 'Design', color: 'linear-gradient(45deg,#333,#c0c0c0)' }
      },
      bezel: {
        none: { icon: '?', value: 'Brak', color: '#666' },
        'flush-15': { icon: '?', value: 'Licująca', color: '#8b4513' },
        'flush-30': { icon: '?', value: 'Licująca', color: '#8b4513' },
        'recessed-15': { icon: '?', value: 'Zagłębiająca', color: '#654321' },
        'recessed-30': { icon: '?', value: 'Zagłębiająca', color: '#654321' },
        'recessed-15-45': { icon: '?', value: 'Zagłębiająca', color: '#654321' }
      },
      fusion: {
        none: { icon: '??', value: 'Brak', color: '#666' },
        fusion: { icon: '??', value: 'FUSION', color: '#ff4500' },
        'fusion-corner': { icon: '??', value: 'CORNER', color: '#ff6347' }
      }
    },
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Szyba dzielona x1 (S2)',
        'single-connected': 'Szyba gięta x1 (S6)',
        double: 'Szyba dzielona x2 (S3)',
        'double-connected': 'Szyba gięta x2 (S7)'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },

  'dragon-aku-2b-xl': {
    name: 'DRAGON AKU 2B XL',
    power: '12 kW',
    type: 'powietrzny-aku',
    glassType: 'narozna',
    image: 'images/dragon-aku-2b-xl.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 2B XL',
    description: 'Wkład powietrzny narożny akumulacyjny 12 kW',
    specialNote: 'Dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych.',
    basePrices: {
      standard: { 
        single: 9630
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 650,
          'flush-30': 740,
          'recessed-15': 850,
          'recessed-30': 970,
          'recessed-15-45': 1050
        }
      },
      fusion: {
        none: 0,
        fusion: 500,
        'fusion-modules': 200
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      glassSize: '760 x 469 mm / 419 mm',
      height: '755 mm',
      width: '674 mm',
      depth: '450 mm',
      weight: '155 kg'
    },
    perkData: {
      variant: {
        standard: { icon: '??', value: 'Standard', color: '#4a9eff' }
      },
      glass: {
        single: { icon: '??', value: 'x1 (S2)', color: '#e6f3ff' }
      },
      ceramic: {
        'refrabox-light': { icon: '??', value: 'Jasna', color: '#f5f1e8' },
        'cerabox-graphite': { icon: '??', value: 'Grafitowa', color: '#4a4a4a' }
      },
      handle: {
        'classic-black': { icon: '??', value: 'Classic', color: '#333' },
        'classic-silver': { icon: '??', value: 'Classic', color: '#c0c0c0' },
        'design-black': { icon: '??', value: 'Design', color: '#1a1a1a' },
        'design-black-silver': { icon: '??', value: 'Design', color: 'linear-gradient(45deg,#333,#c0c0c0)' }
      },
      bezel: {
        none: { icon: '?', value: 'Brak', color: '#666' },
        'flush-15': { icon: '?', value: 'Licująca', color: '#8b4513' },
        'flush-30': { icon: '?', value: 'Licująca', color: '#8b4513' },
        'recessed-15': { icon: '?', value: 'Zagłębiająca', color: '#654321' },
        'recessed-30': { icon: '?', value: 'Zagłębiająca', color: '#654321' },
        'recessed-15-45': { icon: '?', value: 'Zagłębiająca', color: '#654321' }
      },
      fusion: {
        none: { icon: '??', value: 'Brak', color: '#666' },
        fusion: { icon: '??', value: 'FUSION', color: '#ff4500' },
        'fusion-corner': { icon: '??', value: 'CORNER', color: '#ff6347' }
      }
    },
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Szyba dzielona x1 (S2)'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },

  'dragon-aku-4b-slim': {
    name: 'DRAGON AKU 4B SLIM',
    power: '13 kW',
    type: 'powietrzny-aku',
    glassType: 'narozna',
    image: 'images/dragon-aku-4b-slim.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 4B SLIM',
    description: 'Wkład powietrzny narożny akumulacyjny 13 kW',
    specialNote: 'Dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych.',
    basePrices: {
      standard: { 
        single: 10920,
        'single-connected': 12200,
        double: 13700,
        'double-connected': 14980
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 680,
          'flush-30': 780,
          'recessed-15': 870,
          'recessed-30': 1000,
          'recessed-15-45': 1100
        }
      },
      fusion: {
        none: 0,
        fusion: 500,
        'fusion-modules': 200
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '13 kW',
      glassSize: '760 x 510 mm / 419 mm',
      height: '955 mm',
      width: '674 mm',
      depth: '450 mm',
      weight: '170 kg'
    },
    perkData: {
      variant: {
        standard: { icon: '??', value: 'Standard', color: '#4a9eff' }
      },
      glass: {
        single: { icon: '??', value: 'x1 (S2)', color: '#e6f3ff' },
        'single-connected': { icon: '??', value: 'x1 (S6)', color: '#e6f3ff' },
        double: { icon: '??', value: 'x2 (S3)', color: '#b3d9ff' },
        'double-connected': { icon: '??', value: 'x2 (S7)', color: '#b3d9ff' }
      },
      ceramic: {
        'refrabox-light': { icon: '??', value: 'Jasna', color: '#f5f1e8' },
        'cerabox-graphite': { icon: '??', value: 'Grafitowa', color: '#4a4a4a' }
      },
      handle: {
        'classic-black': { icon: '??', value: 'Classic', color: '#333' },
        'classic-silver': { icon: '??', value: 'Classic', color: '#c0c0c0' },
        'design-black': { icon: '??', value: 'Design', color: '#1a1a1a' },
        'design-black-silver': { icon: '??', value: 'Design', color: 'linear-gradient(45deg,#333,#c0c0c0)' }
      },
      bezel: {
        none: { icon: '?', value: 'Brak', color: '#666' },
        'flush-15': { icon: '?', value: 'Licująca', color: '#8b4513' },
        'flush-30': { icon: '?', value: 'Licująca', color: '#8b4513' },
        'recessed-15': { icon: '?', value: 'Zagłębiająca', color: '#654321' },
        'recessed-30': { icon: '?', value: 'Zagłębiająca', color: '#654321' },
        'recessed-15-45': { icon: '?', value: 'Zagłębiająca', color: '#654321' }
      },
      fusion: {
        none: { icon: '??', value: 'Brak', color: '#666' },
        fusion: { icon: '??', value: 'FUSION', color: '#ff4500' },
        'fusion-corner': { icon: '??', value: 'CORNER', color: '#ff6347' }
      }
    },
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Szyba dzielona x1 (S2)',
        'single-connected': 'Szyba gięta x1 (S6)',
        double: 'Szyba dzielona x2 (S3)',
        'double-connected': 'Szyba gięta x2 (S7)'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    }
  },

  'dragon-aku-4b': {
    id: 'dragon-aku-4b',
    name: 'DRAGON AKU 4B',
    power: '16 kW',
    type: 'powietrzny-aku',
    glassType: 'narozna',
    image: 'images/dragon-aku-4b.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 4B',
    description: 'Wkład powietrzny narożny akumulacyjny 16 kW',
    specialNote: 'Dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych.',
    basePrices: {
      standard: { 
        single: 11080,
        'single-connected': 12360,
        double: 13860,
        'double-connected': 15150
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 680,
          'flush-30': 780,
          'recessed-15': 870,
          'recessed-30': 1000,
          'recessed-15-45': 1100
        }
      },
      fusion: {
        none: 0,
        fusion: 500,
        'fusion-modules': 200
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '16 kW',
      glassSize: '760 x 510 mm / 419 mm',
      height: '955 mm',
      width: '674 mm',
      depth: '450 mm',
      weight: '175 kg'
    },
    perkData: {
      variant: {
        standard: { icon: '??', value: 'Standard', color: '#4a9eff' }
      },
      glass: {
        single: { icon: '??', value: 'x1 (S2)', color: '#e6f3ff' },
        'single-connected': { icon: '??', value: 'x1 (S6)', color: '#e6f3ff' },
        double: { icon: '??', value: 'x2 (S3)', color: '#b3d9ff' },
        'double-connected': { icon: '??', value: 'x2 (S7)', color: '#b3d9ff' }
      },
      ceramic: {
        'refrabox-light': { icon: '??', value: 'Jasna', color: '#f5f1e8' },
        'cerabox-graphite': { icon: '??', value: 'Grafitowa', color: '#4a4a4a' }
      },
      handle: {
        'classic-black': { icon: '??', value: 'Classic', color: '#333' },
        'classic-silver': { icon: '??', value: 'Classic', color: '#c0c0c0' },
        'design-black': { icon: '??', value: 'Design', color: '#1a1a1a' },
        'design-black-silver': { icon: '??', value: 'Design', color: 'linear-gradient(45deg,#333,#c0c0c0)' }
      },
      bezel: {
        none: { icon: '?', value: 'Brak', color: '#666' },
        'flush-15': { icon: '?', value: 'Licująca', color: '#8b4513' },
        'flush-30': { icon: '?', value: 'Licująca', color: '#8b4513' },
        'recessed-15': { icon: '?', value: 'Zagłębiająca', color: '#654321' },
        'recessed-30': { icon: '?', value: 'Zagłębiająca', color: '#654321' },
        'recessed-15-45': { icon: '?', value: 'Zagłębiająca', color: '#654321' }
      },
      fusion: {
        none: { icon: '??', value: 'Brak', color: '#666' },
        fusion: { icon: '??', value: 'FUSION', color: '#ff4500' },
        'fusion-corner': { icon: '??', value: 'CORNER', color: '#ff6347' }
      }
    },
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Szyba dzielona x1 (S2)',
        'single-connected': 'Szyba gięta x1 (S6)',
        double: 'Szyba dzielona x2 (S3)',
        'double-connected': 'Szyba gięta x2 (S7)'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-corner': 'FUSION CORNER'
      }
    }
  }
}
